export default "__VITE_ASSET__gli4HT9e__"